import { useAppLayout } from '@context/LayoutContext';

import { Input } from 'antd';
import classNames from 'classnames';
import s from './index.module.less';
import InputArea from './InputArea';
import MediumQuantityButton from './MediumQuanityButton';
import { InputPropsType } from './types';

const MediumNumberInput = ({
  className,
  enableErrorStyle,
  incrementButton,
  decrementButton,
  inputValue,
  input,
  loading,
  disabled,
}: InputPropsType) => {
  const inputStyle = {
    input: classNames(s.mediumInput),
    group: classNames(s.groupMedium, enableErrorStyle && s.error),
  };

  const { isMobile } = useAppLayout();

  return (
    <div className={className}>
      <Input.Group compact className={inputStyle.group}>
        <InputArea
          value={inputValue}
          className={inputStyle.input}
          loading={loading}
          input={input}
          disabled={disabled}
          dataTest="medium-number-input"
        />
        {!isMobile && (
          <MediumQuantityButton
            incrementButton={incrementButton}
            decrementButton={decrementButton}
            disabled={disabled}
          />
        )}
      </Input.Group>
    </div>
  );
};

export default MediumNumberInput;
